export default "__VITE_ASSET__DAdnqQw9__"